import { getFiatCurrencyForMarket } from '@/libs/market/market';
import { useUserMeQuery } from '@/queries/user/user.queries';

/**
 * Fiat presentation context for a new user-scoped operation.
 * Persisted orders, transactions, withdrawals, and limits must keep using
 * the currency stored on the entity instead.
 */
export const useMarketFiatCurrency = () => {
  const userQuery = useUserMeQuery();
  const market = userQuery.data?.market ?? 'US';

  return {
    currency: getFiatCurrencyForMarket(market),
    market,
    isReady: Boolean(userQuery.data),
    isLoading: userQuery.isLoading,
  };
};
